import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AduanasPuertos.css"; 

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';
const PLACEHOLDER_IMAGE = "https://placehold.co/600x400/eeeeee/cccccc?text=Sin+Imagen";


export default function Aduanas() {
  const [items, setItems] = useState([]);
  const [tipoActivo, setTipoActivo] = useState("Puerto"); 
  const navigate = useNavigate();

  const tipos = [
    { id: "Puerto", label: "Puerto", icon: "fas fa-ship" },
    { id: "Aduanas", label: "Aduana", icon: "fas fa-money-bill" }, 
  ];

  useEffect(() => {
    const endpoint = tipoActivo; 

    if (tipoActivo === "Puerto") {
      document.body.classList.add("body-fondo-puerto");
    } else {
      document.body.classList.remove("body-fondo-puerto");
    }

    fetch(`${API_BASE_URL}/api/${endpoint}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Error ${res.status}: No se pudo encontrar /api/${endpoint}`);
        }
        return res.json();
      })
      .then((data) => {
        setItems(data);
      })
      .catch((err) => {
        console.error("Error al cargar datos:", err);
        setItems([]); 
      });
      
  }, [tipoActivo]); 

  const irADetalle = (id) => {
    const path = tipoActivo.toLowerCase(); 
    navigate(`/${path}/${id}`);
  };

  return (
    <div className="Filtro aduanas">
      <div className="tabs-container">
        {tipos.map((tipo) => (
          <div
            key={tipo.id}
            className={`tab ${tipoActivo === tipo.id ? "active" : ""}`}
            onClick={() => setTipoActivo(tipo.id)}
          >
            <i className={tipo.icon}></i>
            <span>{tipo.label}</span>
          </div>
        ))}
      </div>

      <div className="contenedor-aduanas"> 
        
        <h2>
          {tipoActivo === 'Aduanas' ? 'Aduanas' : 'Puertos'}
        </h2> 
        
        {tipoActivo === "Aduanas" && (
          <p>Las aduanas controlan el comercio.</p>
        )}
        {tipoActivo === "Puerto" && (
          <p>Los puertos permiten el paso de la mercancia para que entre o salga del país.</p>
        )}

        <div className="lista-items"> 
          {items.length === 0 ? (
            <p>No hay {tipoActivo.toLowerCase()} registrados en esta categoría.</p>
          ) : (
            items.map((item) => {
          
              const locationString = item.ubicacion || [item.estado, item.municipio].filter(Boolean).join(', ');

              return (
                <div
                  key={item.id}
                  className={`tarjeta-${tipoActivo.toLowerCase()}`} 
                  onClick={() => irADetalle(item.id)}
                >
                  
                  <img 
                    src={item.urlImagen || PLACEHOLDER_IMAGE} 
                    alt={`Imagen de ${item.nombre}`}
                    style={{ 
                      width: '100%', 
                      height: '150px', 
                      objectFit: 'cover', 
                      borderRadius: '8px 8px 0 0',
                      marginBottom: '10px',
                      backgroundColor: '#eee' 
                    }}
                    onError={(e) => { 
                      e.target.src = PLACEHOLDER_IMAGE; 
                    }}
                  />

                  <h4>{item.nombre}</h4>
                  

                  {locationString && <p>{locationString}</p>}
                  
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}